import React, { useState } from "react";
import { toast } from "sonner";
import { Send, Mail, MessageSquare, X, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function SendIntakeDialog({ consultationId, patient, onClose }) {
    const [channel, setChannel] = useState("email");
    const [email, setEmail] = useState(patient?.email || "");
    const [phone, setPhone] = useState(patient?.phone || "");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post(`/consultations/${consultationId}/send-intake`, {
                channel, email: email || null, phone: phone || null,
            });
            const anyReal = (data.results || []).some(r => r.status === "sent");
            const anyMock = (data.results || []).some(r => r.status === "mocked");
            if (anyReal) toast.success("Link enviado com sucesso!");
            else if (anyMock) toast.info("Envio simulado (chaves não configuradas). Link registrado no log.");
            else toast.error("Nenhum canal disponível.");
            onClose();
        } catch (err) { toast.error(formatApiError(err)); }
        finally { setLoading(false); }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 relative">
                <button onClick={onClose} className="absolute top-3 right-3 text-muted-clinical hover:text-brand"><X size={16} /></button>
                <h3 className="font-display text-xl font-medium text-brand mb-1">Enviar link ao paciente</h3>
                <p className="text-sm text-muted-clinical mb-4">Escolha o canal e confirme os dados de contato.</p>
                <form onSubmit={submit} className="space-y-4">
                    <div className="grid grid-cols-3 gap-2">
                        {[
                            { v: "email", l: "E-mail", Icon: Mail },
                            { v: "whatsapp", l: "WhatsApp", Icon: MessageSquare },
                            { v: "all", l: "Ambos", Icon: Send },
                        ].map((o) => {
                            const on = channel === o.v;
                            const Icon = o.Icon;
                            return (
                                <button
                                    key={o.v}
                                    type="button"
                                    onClick={() => setChannel(o.v)}
                                    data-testid={`send-channel-${o.v}`}
                                    className={`p-3 rounded-lg border-2 text-sm flex flex-col items-center gap-1 transition-colors ${on ? "border-brand bg-alt text-brand" : "border-transparent bg-alt/50 text-muted-clinical hover:text-brand"}`}
                                >
                                    <Icon size={16} /> {o.l}
                                </button>
                            );
                        })}
                    </div>
                    {(channel === "email" || channel === "all") && (
                        <div>
                            <label className="label-clinical">E-mail do paciente/cuidador</label>
                            <input data-testid="send-email-input" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-clinical" placeholder="paciente@email.com" />
                        </div>
                    )}
                    {(channel === "whatsapp" || channel === "all") && (
                        <div>
                            <label className="label-clinical">WhatsApp (com DDD e +55)</label>
                            <input data-testid="send-phone-input" required value={phone} onChange={(e) => setPhone(e.target.value)} className="input-clinical" placeholder="+5511999999999" />
                        </div>
                    )}
                    <button data-testid="send-intake-submit" disabled={loading} className="btn-primary w-full">
                        {loading ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />} Enviar link
                    </button>
                </form>
            </div>
        </div>
    );
}
